import React from 'react';
import { PRODUCT, SUPPORT_EMAIL } from '../data/constants';
export function Footer() {
  return <footer className="border-t-4 border-gold bg-navy py-4" data-id="element-62" data-mp="3gfsjo3v2keir">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-63" data-mp="3gh3qkcjta2e3">
        <p className="text-xs font-semibold leading-snug text-white/85 sm:text-sm" data-id="element-64" data-mp="32ovz90bar3ms">
          © 2026 {PRODUCT} — Tous droits réservés.
        </p>
        <p className="mt-1 text-xs leading-snug text-white/70 sm:text-sm" data-id="element-65" data-mp="36n3axgqwler4">
          Support pédagogique destiné aux infirmiers, étudiants et professionnels de santé. Ne
          remplace ni la formation, ni l’avis médical, ni les protocoles de l’établissement. Les
          tracés sont pédagogiques.
        </p>
        <p className="mt-1.5 text-xs font-semibold uppercase tracking-wide text-white/70 sm:text-sm" data-id="element-66" data-mp="3qd6pzana3mxc">
          Conditions générales • Politique de confidentialité • Contact
        </p>
        <p className="mt-1 text-xs text-white/70 sm:text-sm" data-id="element-67" data-mp="2a1jhr4jztm0c">
          Assistance :{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-white underline decoration-gold underline-offset-2 transition-colors duration-150 ease-out hover:text-tech-light" data-id="element-68" data-mp="2evx8uurmh6z7">
            {SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    </footer>;
}